import React from 'react';

export type AccordionItemContextProps = {
  expanded: boolean;
  toggleExpansion: () => void;
  panelId: string;
};

export const AccordionItemContext =
  React.createContext<AccordionItemContextProps>(
    {} as AccordionItemContextProps
  );
